// Platform detection + native feature helpers.
// The React web app uses this to enable native features when running inside
// the Capacitor Android/iOS shell.
import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isWeb = () => Capacitor.getPlatform() === 'web';

// Initialize native chrome (status bar + hide splash) once on app boot.
export async function initNativeShell() {
  if (!isNative()) return;
  try {
    const { StatusBar, Style } = await import('@capacitor/status-bar');
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#0f172a' });
  } catch (e) {
    // Plugin might not be available; ignore silently.
  }
  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    // Give the app a moment to render then hide the native splash.
    setTimeout(() => SplashScreen.hide().catch(() => {}), 800);
  } catch (e) {
    // ignore
  }
}

// Persist auth token to native Preferences (survives app uninstall on iOS Keychain
// on iOS; SharedPreferences on Android) so users don't need to re-login every launch.
export async function nativeSetItem(key, value) {
  if (!isNative()) {
    localStorage.setItem(key, value);
    return;
  }
  try {
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.set({ key, value });
  } catch {
    localStorage.setItem(key, value);
  }
}

export async function nativeGetItem(key) {
  if (!isNative()) return localStorage.getItem(key);
  try {
    const { Preferences } = await import('@capacitor/preferences');
    const { value } = await Preferences.get({ key });
    return value;
  } catch {
    return localStorage.getItem(key);
  }
}

export async function nativeRemoveItem(key) {
  if (!isNative()) {
    localStorage.removeItem(key);
    return;
  }
  try {
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.remove({ key });
  } catch {
    localStorage.removeItem(key);
  }
}
